// @flow

import wx from '@caofeilong/weixin_js'

export function hideMenu () {
  wx.ready(function () {
    wx.hideAllNonBaseMenuItem()
  })
}

export function showMenu () {
  wx.ready(function () {
    wx.showAllNonBaseMenuItem()
  })
}



// WEBPACK FOOTER //
// ./src/frame/core/wx.js